<template lang="pug">
  div.fill-height
    slot(:open="open")
    ModalWrapper(
      :header-text="$t('form.user.point.title')",
      icon="coins",
      :dialog="dialog",
      @close="close",
    )
      template(v-slot:body="")
        div(v-if="!custom")
          v-list.reward_list(three-line)
            v-list-item(
              v-if="isSuperadmin",
              @click="showCustom",
            )
              v-list-item-avatar
                div.reward_points ?
              v-list-item-content
                v-list-item-title {{ $t('form.user.point.custom_title') }}
                v-list-item-subtitle {{ $t('form.user.point.custom_description') }}
            v-list-item(
              :class="{ active: selected === template.id }",
              v-for="template in templates",
              :key='template.id',
              @click="selectTemplate(template)",
            )
              v-list-item-avatar
                div.reward_points {{ template.points }}
              v-list-item-content
                v-list-item-title {{ template.name }} 
                v-list-item-subtitle {{ template.description }}

        div(v-if="custom")
          v-row
            v-col(sm="6")
              TextBox(
                :value.sync="data.name"
                label="Name",
                :error-messages="errors.name",
                @update:value="clearError('name')",
              )
            v-col(sm="6")
              NumberBox(
                :value.sync="data.points",
                label="Points",
                :error-messages="errors.points",
                @update:value="clearError('points')",
              )
          v-row
            v-col(sm="12")
              TextBox(
                :value.sync="data.description",
                label="Description",
                :error-messages="errors.description",
                @update:value="clearError('description')",
              )
      template(v-slot:footer="")
        v-btn(
          v-if="custom",
          :ripple="false",
          color="primary",
          @click="back",
        ) {{ $t('form.user.point.back') }}
        v-spacer
        v-btn(
          :disabled="isLoading",
          :ripple="false",
          color="primary",
          @click='close'
        ) {{ $t('form.user.point.cancel') }}

        v-btn(
          color="primary",
          :disabled="invalid",
          :ripple="false",
          :loading="isLoading",
          @click="submit",
        ) {{ $t('form.user.point.reward') }}
</template>

<script>
import { mapGetters } from 'vuex';
import { clone, pick } from 'ramda';

import ModalWrapper from '@/components/wrapper/ModalWrapper.vue';
import { formHelper, roleManager } from '@/config/mixins';

export default {
  mixins: [formHelper, roleManager],

  components: {
    ModalWrapper,
  },

  data: () => ({
    dialog: false,
    data: {},
    isUpload: false,
    custom: false,
    selected: null,
  }),

  computed: {
    ...mapGetters({ templates: 'rewardTemplate/items' }),

    invalid() {
      if (this.custom) {
        return this.hasError || !this.valid;
      } else {
        return !this.selected;
      }
    },
  },

  methods: {
    open() {
      this.custom = false;
      this.selected = null;
      this.data = clone(this.model);
      this.dialog = true;
      this.reset();
      this.flushError();
    },

    close() {
      this.dialog = false;
    },

    back() {
      this.custom = false;
      this.data = clone(this.model);
      this.selected = null;
    },

    showCustom() {
      this.custom = true;
      this.data = clone(this.model);
      this.selected = null;
    },

    selectTemplate(template) {
      this.selected = template.id;
      this.data = pick(['name', 'description', 'points'], template);
    },

    submit() {
      this.wrapProgress(() =>
        this.$store
          .dispatch(
            `reward/create`,
            {
              userId: this.$route.params.id,
              data: this.data,
            },
            { root: true },
          )
          .then(() => {
            this.$emit('updated');
            this.close();
          })
          .catch(this.setError),
      );
    },
  },
};
</script>
